<div>
  <div>
    <p class="article_text_left">
      OCCON GmbH <br />
      Schillerplatz 12-14 <br />
      67071 Ludwigshafen <br />
      Germany <br />
      <br />
    </p>
  </div>
  <div>
    <p class="article_text_left">
      {{ "IMPRINT.PHONE" | translate : locale.language }} &emsp;&emsp;
      <a href="tel:+496215968326210" class="external-link">
        +49 621 5968 3262 - 10
      </a>
      <br />
      {{ "IMPRINT.MAIL" | translate : locale.language }}
      &emsp;&emsp;&nbsp;&nbsp;
      <a href="mailto:info@occon.de " class="external-link">
        info&#64;occon.de
      </a>
      <br />
      {{ "IMPRINT.WEBSITE" | translate : locale.language }} &emsp;&nbsp;&nbsp;
      <a
        href="http://www.occon.de"
        class="external-link"
        target="_blank"
        rel="noopener"
      >
        www.occon.de
      </a>
    </p>
  </div>
</div>
<div>
  <div>
    <p class="article_text_left">
      {{ "IMPRINT.MANAGING_DIRECTORS" | translate : locale.language }}
    </p>
  </div>
  <div>
    <p class="article_text_left">Joachim Stellner, Sabrina Bähr</p>
  </div>
</div>
<div>
  <div>
    <p class="article_text_left">
      {{ "IMPRINT.COURT" | translate : locale.language }}
    </p>
  </div>
  <div>
    <p class="article_text_left">HRB 61262</p>
  </div>
</div>
<div>
  <div>
    <p class="article_text_left">
      {{ "IMPRINT.UST_ID" | translate : locale.language }}
    </p>
  </div>
  <div>
    <p class="article_text_left">DE814906056</p>
  </div>
</div>
<div>
  <div>
    <p class="article_text_left">
      {{ "IMPRINT.RESPONSIBLE" | translate : locale.language }}
    </p>
  </div>
  <div>
    <p class="article_text_left">
      Joachim Stellner, Sabrina Bähr <br />
      <br />
    </p>
  </div>
</div>
